// TOP LEVEL IMPORTS
import React from 'react';
import PropTypes from 'prop-types';
import { propType } from 'graphql-anywhere';
// ANTD
import Table from 'antd/lib/table';
// APOLLO
import contactFormEntryFragment from 'ApolloClient/Fragments/contactFormEntryFragment';
// LIB
import GeneralHelpers from 'lib/helpers/GeneralHelpers';
// COMPONENTS
import Button from 'components/common/Button';

const columns = handleClick => [
  {
    title: 'DATE',
    dataIndex: 'createdAt',
    key: 'createdAt',
    render: (text, record) => (
      <div>{(record && record.createdAt && GeneralHelpers.formatTableDate(record.createdAt)) || ''}</div>
    ),
  },
  {
    title: '',
    dataIndex: '_id',
    key: '_id',
    render: (text, record) => (
      <Button
        className="right"
        onClick={() => {
          handleClick(record);
        }}
      >
        VIEW
      </Button>
    ),
  },
];

const ContactFormEntriesTable = ({ contactFormEntries, onClick, pagination }) => (
  <Table
    rowKey={record => record._id}
    columns={columns(onClick)}
    dataSource={contactFormEntries}
    pagination={pagination}
  />
);

ContactFormEntriesTable.propTypes = {
  contactFormEntries: PropTypes.arrayOf(propType(contactFormEntryFragment)).isRequired,
  onClick: PropTypes.func,
  pagination: PropTypes.shape({
    defaultPageSize: PropTypes.number,
  }),
};

ContactFormEntriesTable.defaultProps = {
  onClick: () => {},
  pagination: { defaultPageSize: 10 },
};

export default ContactFormEntriesTable;



// WEBPACK FOOTER //
// ./src/routes/app-client-detail/ClientContactFormEntries/ContactFormEntriesTable/index.js